<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as R from 'ramda'
import { mapMutations } from 'vuex'
import { setupReplaceTableCSV, fetchIgnoreStudentsCSV } from '@/services/csv.js'
import Promise from 'bluebird'
const csvReplaceTable = require('dsv-loader!../spec/replace.csv');
const specJson = require('../spec/spec' + process.env.VUE_APP_YEAR + '.json');
const DataStore = require('nedb')

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      //
    }
  },
  methods: {
    ...mapMutations([
      'updateCsvReplaceTable',
      'updateSpecsList',
      'updateSpecBorder',
      'updateCourceLabels',
      'updateIgnoreStudents'
    ])
  },
  async created () {

    Promise.promisifyAll(DataStore.prototype)
    Vue.prototype.$xlsxdb = new DataStore()

    this.updateCsvReplaceTable({ 
      table: setupReplaceTableCSV(csvReplaceTable)
    })
    // MEMO: selectTotalとmustTotalは2018には存在しない
    const { total, freeTotal, selectTotal = null, mustTotal = null  } = specJson
    // debugger
    this.updateSpecBorder({
      specBorder: {total, freeTotal, selectTotal, mustTotal}
    })

    const cources = R.keys(specJson.models)
    const labels = []
    R.forEach(key => labels.push(specJson.models[key].label || 'none'), cources) 
    const courceLabels = R.zipObj(cources, labels) // [{Y7: 'デザイン', Y11: 'hoge..}]
    
    this.updateCourceLabels({
      courceLabels
    })
    
    try {
      const ignoreStudents = await fetchIgnoreStudentsCSV()
      this.updateIgnoreStudents({ list: ignoreStudents })
    } catch (e) {
      throw new Error(e)
    }
  }
}
</script>
